import { IonIcon } from "@ionic/react";
import classNames from "classnames/bind";
import { closeOutline, heart, heartOutline } from "ionicons/icons";
import React from "react";
import styles from "./NewListViewProduct.module.scss";
import { Product } from "@core/types";
import { useWishListData } from "../../../../../providers/wishListStore";

interface WishlistButtonProps {
  product: Product;
  type: "list-for-wish" | "newList";
}

const cx = classNames.bind(styles);

export const WishlistButton = ({ product, type }: WishlistButtonProps) => {
  const { toggleWish, isWishProduct } = useWishListData();

  return (
    <div className={cx("productsSpecialLeft__heart", "ion-hide-sm-up")}>
      {type === "list-for-wish" ? (
        <div
          onClick={(e) => {
            toggleWish(product.id);
            e.stopPropagation();
          }}
          className={cx("wishProduct__removeButton")}
        >
          <IonIcon icon={closeOutline} className={"wishList__removeIcon"} />
        </div>
      ) : !isWishProduct(product.id) ? (
        <div
          onClick={(e) => {
            toggleWish(product.id);
            e.stopPropagation();
          }}
        >
          <IonIcon color="secondary" className={cx("productHeartIcon")} icon={heartOutline} />
        </div>
      ) : (
        <div
          onClick={(e) => {
            toggleWish(product.id);
            e.stopPropagation();
          }}
        >
          <IonIcon className={cx("productHeartIcon")} color="secondary" icon={heart} />
        </div>
      )}
    </div>
  );
};
